/*----- Core -----*/
import React       from 'react'
import { connect } from "react-redux"

/*----- Styles -----*/
import Styles from './Styles'

/*----- Ant Design -----*/
import { Row, Col } from 'antd'

/*----- Selectors -----*/
import { sessionIsLoadingSelector } from './Selectors'

/*----- Actions -----*/
import { login } from './Actions'

/*----- Assets -----*/
import Logo	from '../../assets/logo.svg'

/*----- Components -----*/
import SectionContainer from '../../components/commons/SectionContainer'
import InputContainer   from '../../components/form/InputContainer'
import HandlerButton    from '../../components/button/HandlerButton'
import Spinner          from '../../components/commons/Spinner'

/*----- Ant design -----*/
import { Input, Form }  from 'antd'
import HeroParagraph from '../../components/hero/HeroParagraph'

function LoginForm({ login, sessionIsLoading }) {

	const [form] = Form.useForm()

	const handleFormSubmit = login => {
    login(form.getFieldValue())
  }

	if(sessionIsLoading) {
		return (
			<Styles>
				<Spinner/>
			</Styles>
		)
	}
	return (
		<SectionContainer noSpacing>
			<Styles>
					<Row style={{width: '100%'}}>
						<Col xs={24} sm={24} md={24} lg={12} xl={12}>
							<HeroParagraph title="Bienvenido al sistema de gestión de productores." />
						</Col>
						<Col xs={24} sm={24} md={24} lg={12} xl={12}>
							<div className="login-form-container">
								<div className="login__logo-container">
									<img src={Logo} alt="logo" className="login__logo"/>
								</div>
								<Form
									layout				 = "vertical"
									name           =  "login-form"
									initialValues  = {{ remember: true }}
									form           = { form }
								>
									<InputContainer>
										<Form.Item
											label	=	"email"
											name 	=	"email"
											rules	=	{[{'required': true, 'type': 'email', message: 'Ingresá tu email' }]}
										>
											<Input size="large" placeholder="email"/>
										</Form.Item>
									</InputContainer>
									<InputContainer>
										<Form.Item
											label = "Password"
											name  = "password"
											rules = {[{ required: true, message: 'Ingresá tu contraseña' }]}
										>
											<Input.Password size="large" />
										</Form.Item>
									</InputContainer>
									<InputContainer>
										<Form.Item className="button-container">
											<HandlerButton content="ingresar"  onClick = { (event) => { handleFormSubmit(login) }} />
										</Form.Item>
									</InputContainer>
								</Form>
							</div>
						</Col>
					</Row>

			</Styles>
		</SectionContainer>
	)
}

const mapStateToProps = (state) => {
  return {
		sessionIsLoading: sessionIsLoadingSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		login: (params) => login(dispatch, params)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm)

